 var swiper = new Swiper(".home_banner-slider", {
      slidesPerView: 1,
      loop: true,
        effect: "fade",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
         breakpoints: {
    320: {
      slidesPerView: 1,
    },
    480: {
      slidesPerView: 1,
    },
    640: {
      slidesPerView: 1,
    },
    1200: {
      slidesPerView: 1,
    },
  },
});


$(document).ready(function() {
   var swiper2 = new Swiper(".top-selling", {
    loop: true,
    slidesPerView: 4,
    paginationClickable: true,
    spaceBetween: 25,
    speed: 1000,
    breakpoints: {
      1028: {
        slidesPerView: 4,
        spaceBetween: 25
      },
      320: {
        slidesPerView: 1.5,
        spaceBetween: 10
      }
    },
  });
});

var swiper3 = new Swiper(".shopby-collection", {
  slidesPerView: 4,
  spaceBetween: 30,
  centeredSlides: false,
  speed: 1000,
  loop: true,
   navigation: {
      nextEl: ".section-collection-list .swiper-button-next",
      prevEl: ".section-collection-list .swiper-button-prev"
    },
    autoplay: {
    delay: 2500,
    pauseOnMouseEnter: true,
  },
    breakpoints: {
      0: {
        spaceBetween: 10,
        slidesPerView: 1
      },
      541: {
        spaceBetween: 20,
        slidesPerView: 2
      },
      800: {
        spaceBetween: 25,
        slidesPerView: 3
      },
      1200: {
        spaceBetween: 25,
        slidesPerView: 4
      }
    },
});

var swiper4 = new Swiper(".featured-cat", {
  slidesPerView: 1,
  speed: 1000,
  spaceBetween: 20,
  loop: true,
  speed: 2000,
  autoplay: {
    delay: 2000,
    disableOnInteraction: true,
    pauseOnMouseEnter: true,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});



const sliderThumbs = new Swiper('.slider__thumbs .swiper-container', { 
	direction: 'vertical', 
	slidesPerView: 4, 
	spaceBetween: 10, 
	navigation: { 
		nextEl: '.slider__next', 
		prevEl: '.slider__prev' 
	},
	freeMode: true, 
	breakpoints: { 
		0: { 
			direction: 'horizontal', 
		},
		768: { 
			direction: 'vertical', 
		}
	}
});

const sliderImages = new Swiper('.slider__images .swiper-container', { 
	direction: 'vertical', 
	slidesPerView: 1, 
	spaceBetween: 0, 
	mousewheel: true, 
	navigation: { 
		nextEl: '.slider__images .swiper-container .slider__next', 
		prevEl: '.slider__images .swiper-container .slider__prev' 
	},
	grabCursor: true, 
	thumbs: { 
		swiper: sliderThumbs 
	},
	breakpoints: { 
		0: { 
			direction: 'horizontal', 
		},
		768: { 
			direction: 'vertical', 
		}
	}
});




    $(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });

      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });

    });

  });

